import Vue from "vue"
/* import zonesApi from "../../api/zones" */
import utilsApi from "../../api/utils"
//import axios from "axios"

const initialObject = {
  _id: undefined,

  isDefault: false,
  name: undefined,
  status: undefined,
  short_name: undefined,
  countries: undefined,
  currency: undefined,
  locales: [],
  default_locale: undefined,
  countries_contained: false,
  shipping_methods: undefined,
  payment_methods: undefined,
  media: undefined,

  createdAt: undefined,
  updatedAt: undefined
}
const ignoreObjectsFields = ["createdAt", "updatedAt"]
// general state for the site

/* const typeValue = {
  typeD: ""
}
 */
const initialState = {
  zones: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  zones: (state) => state.zones,
  //zones: () => zones,
  zonesIndex: (state) => (payload) => {
    //console.log(state.zones)
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  zonesError: (state) => state.error,
  zones_Object: (state) => state.object,
  zones_isNew: (state) => state.isNew,
  zones_selected: (state) => state.selected,
  zones_dataShape: (state) => state.dataShape,
  count: (state) => state.count
}
const actions = {
  UPDATE_state({ commit }, payload) {
    commit("SET_zones", payload)
    return true
  },

  async DELETE_zones({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("zones", object)
    if (apiResponse != null) {
      //commit("ZONES_SETTING", apiResponse)
      dispatch("FETCH_PAGE_zones", state.page)
      return true
    } else {
      commit("ZONES_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_zones({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_zones", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_zones", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_zonesState({ commit }, payload) {
    commit("SET_zones", payload)
    //console.log("payload UPDATE", payload)
    return true
  },
  async UPDATE_zones({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject("zones", filtered)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("ZONES_SETTING", apiResponse)
      dispatch("FETCH_PAGE_zones", state.page)
      return true
    } else {
      commit("ZONES_ERROR")
      return false
    }
  },
  async CREATE_zones({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("zones", object)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("SET_zones", {
        param: "object",
        value: apiResponse.zone
      })
      dispatch("FETCH_PAGE_zones", state.page)
      return true
    } else {
      commit("ZONES_ERROR")
      return false
    }
  },
  async FETCH_zones({ commit }) {
    let apiResponse = await utilsApi.getObjects("zones")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("ZONES_SETTING", apiResponse)
      return true
    } else {
      commit("ZONES_ERROR")
      return false
    }
  },

  async FETCH_PAGE_zones({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("zones", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("ZONES_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("ZONES_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_zones({ commit }, payload) {
    commit("SET_OBJECT_ZONE", payload)
    return true
  },
  CLEAN_OBJECT_zones({ commit }) {
    commit("SET_OBJECT_ZONE_INITIAL")
    return true
  },
  async CLEAN_STORE_zones({ commit }) {
    const initialStateKeys = Object.keys(initialState)
    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_zones", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )
    return true
  },
  UPDATE_SELECTED_zones({ commit }, payload) {
    commit("SET_SELECTED_ZONES", payload)
    return true
  }
}
const mutations = {
  ZONES_SETTING: (state, { zones, count = false }) => {
    //console.log("CHECK STATE", zones)
    state.count = count || state.zones.length
    state.zones = zones
    state.fetched = true
    state.error = false
  },
  ZONES_ERROR: (state) => {
    state.zones = null
    state.fetched = true
    state.error = false

    state.dataShape = []
  },
  SET_OBJECT_ZONE: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_ZONE_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_ZONES: (state, selectedZones) => {
    state.selected = selectedZones
  },
  SET_zones: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
